import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/fonts.css';
import ContactForm from './ContactForm';

const gradientTextStyle = {
    background: 'linear-gradient(to right, #ff0000 5%, #ff8c00 10%, #ffd700 65%, #ff69b4 85%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text'
};

function Homepage() {
    const navigate = useNavigate();
    
    return (
        <div className="overflow-hidden">
            <div className='row g-0'>
                <div className="col-12 p-0 position-relative">
                    <img
                        src="/homeBanner.png"
                        alt="Home Banner"
                        className="img-fluid w-100"
                        style={{
                            height: 'clamp(400px, 50vh, 600px)',
                            objectFit: 'cover'
                        }}
                    />
                    <div className="container-fluid px-4 px-md-5 position-absolute start-0 top-50 translate-middle-y" style={{ maxWidth: '1270px', margin: '0 auto' }}>
                        <div className="row justify-content-center">
                            <div className="col-12 col-lg-10 text-white">
                                <img
                                    src="/textLogo.png"
                                    alt="Home Banner"
                                    className="img-fluid"
                                    style={{
                                        maxWidth: '480px',
                                        width: '80%',
                                        objectFit: 'contain',
                                        display: 'block'
                                    }}
                                />
                                <div className="text-start mt-4">
                                    <h1 className="display-5 my-2" style={{
                                        fontFamily: 'Avenir, sans-serif',
                                        fontWeight: '900',
                                        fontSize: 'clamp(20px, 3.5vw, 60px)'
                                    }}>
                                        Tech-Driven, Future Ready
                                    </h1>
                                </div>
                                <div className='row d-flex align-items-start justify-content-start g-2'>
                                    <div className='col-auto me-5'>
                                        <p className="mb-2 mb-md-0 text-start" style={{
                                            fontFamily: 'Avenir, sans-serif',
                                            fontWeight: 'bold',
                                            fontSize: 'clamp(16px, 2.5vw, 36px)'
                                        }}>Transform Your Business Today</p>
                                    </div>
                                    <div className='col-auto'>
                                        <button className="btn rounded-0" 
                                            onClick={() => window.location.href = '/about'} 
                                            style={{ 
                                                width: '200px', 
                                                height: '56px', 
                                                backgroundColor: '#BC2025', 
                                                color: 'white',
                                                fontSize: '16px',
                                                fontWeight: 'bold',
                                                fontFamily: 'Avenir, sans-serif'
                                            }}>
                                            <span>Learn More</span>
                                            <img src="/arrow.png" alt="arrow" style={{ width: '20px', height: '20px' }} />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div style={{ maxWidth: '1270px', margin: '0 auto' }}>
                {/* Services Section */}
                <div className="container-fluid px-4 px-md-5 py-5">
                    <div className="row justify-content-center align-items-center">
                        <div className="col-12" >
                            <h1 className="display-4 text-start mb-0"
                                style={{
                                    ...gradientTextStyle,
                                    fontFamily: 'Godber, sans-serif',
                                    fontSize: '40px'
                                }}>
                                Our Services
                            </h1>
                            <div className="row d-flex align-items-center justify-content-between mb-4">
                                <div className="col-auto">
                                    <h2 className="mb-2 text-start" style={{ fontFamily: 'Avenir, sans-serif', fontSize: 'clamp(24px, 2vw, 36px)', fontWeight: '700' }}>
                                        Tech-Driven, Future Ready
                                    </h2>
                                </div>
                                <div className="col-auto">
                                    <button className="btn rounded-0" 
                                        onClick={() => navigate('/services')} 
                                        style={{ 
                                            width: 'clamp(180px, 20vw, 200px)', 
                                            height: 'clamp(40px, 5vh, 56px)', 
                                            backgroundColor: '#BC2025', 
                                            color: 'white',
                                            fontSize: '16px',
                                            fontWeight: 'bold',
                                            fontFamily: 'Avenir, sans-serif'
                                        }}>
                                        <span className="me-3">Our Services</span>
                                        <img src="/arrow.png" alt="arrow" style={{ width: '20px', height: '20px' }} />
                                    </button>
                                </div>
                            </div>

                            <div className="row row-cols-1 row-cols-md-2 g-0">
                                <div className="col">
                                    <div className="card rounded-0 border border-1">
                                        <div className="card-body text-start p-4">
                                            <h5 className="card-title mb-0" style={{
                                                color: '#BC2025',
                                                fontFamily: 'Godber, sans-serif',
                                                fontSize: '28px'
                                            }}>Digital Transformation</h5>
                                            <span className="card-text font-weight-bold d-flex align-items-center mb-3" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                <i className="bi bi-arrow-right-short" style={{ fontSize: '24px', fontWeight: 'bold' }}></i>
                                                <span>(Server Hardware)</span>
                                            </span>
                                            <img src="/services/digitalTransformation.png" alt="Server Hardware" className="img-fluid mb-2" style={{ maxWidth: '100%', height: 'auto', borderRadius: '10px' }} />
                                            <span className="card-text d-flex align-items-center" style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '-14px' }}>
                                                <i className="bi bi-arrow-right-short" style={{ fontSize: '24px', fontWeight: 'bold' }}></i>
                                                <span style={{ color: '#BC2025', fontFamily: 'Avenir, sans-serif' }}>Data Center Solutions</span>
                                            </span>
                                            <span className="card-text d-flex align-items-center" style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '-14px' }}>
                                                <i className="bi bi-arrow-right-short" style={{ fontSize: '24px', fontWeight: 'bold' }}></i>
                                                <span style={{ color: '#BC2025', fontFamily: 'Avenir, sans-serif' }}>Cloud Infrastructure Solutions</span>
                                            </span>
                                            <span className="card-text d-flex align-items-center" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                <i className="bi bi-arrow-right-short" style={{ fontSize: '24px', fontWeight: 'bold' }}></i>
                                                <span style={{ color: '#BC2025', fontFamily: 'Avenir, sans-serif' }}>Virtualization & Compute Solutions</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div className="col">
                                    <div className="card rounded-0 border border-1">
                                        <div className="card-body text-start p-4">
                                            <h5 className="card-title mb-0" style={{
                                                color: '#BC2025',
                                                fontFamily: 'Godber, sans-serif',
                                                fontSize: '28px'
                                            }}>Enterprise Solutions</h5>
                                            <span className="card-text font-weight-bold d-flex align-items-center mb-3" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                <i className="bi bi-arrow-right-short" style={{ fontSize: '24px', fontWeight: 'bold' }}></i>
                                                <span>(System Integration)</span>
                                            </span>
                                            <img src="/services/systemIntegration.png" alt="Server Hardware" className="img-fluid mb-2" style={{ maxWidth: '100%', height: 'auto', borderRadius: '10px' }} />
                                            <span className="card-text d-flex align-items-center" style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '-14px' }}>
                                                <i className="bi bi-arrow-right-short" style={{ fontSize: '24px', fontWeight: 'bold' }}></i>
                                                <span style={{ color: '#BC2025', fontFamily: 'Avenir, sans-serif' }}>ERP & CRM Integration</span>
                                            </span>
                                            <span className="card-text d-flex align-items-center" style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '-14px' }}>
                                                <i className="bi bi-arrow-right-short" style={{ fontSize: '24px', fontWeight: 'bold' }}></i>
                                                <span style={{ color: '#BC2025', fontFamily: 'Avenir, sans-serif' }}>IT Infrastructure Integration</span>
                                            </span>
                                            <span className="card-text d-flex align-items-center" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                <i className="bi bi-arrow-right-short" style={{ fontSize: '24px', fontWeight: 'bold' }}></i>
                                                <span style={{ color: '#BC2025', fontFamily: 'Avenir, sans-serif' }}>Cybersecurity Integration</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div className="col">
                                    <div className="card rounded-0 border border-1">
                                        <div className="card-body text-start p-4">
                                            <h5 className="card-title mb-0" style={{
                                                color: '#BC2025',
                                                fontFamily: 'Godber, sans-serif',
                                                fontSize: '28px'
                                            }}>Software Development</h5>
                                            <span className="card-text font-weight-bold d-flex align-items-center mb-3" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                <i className="bi bi-arrow-right-short" style={{ fontSize: '24px', fontWeight: 'bold' }}></i>
                                                <span>(Custom Applications)</span>
                                            </span>
                                            <img src="/services/customApplications.png" alt="Server Hardware" className="img-fluid mb-2" style={{ maxWidth: '100%', height: 'auto', borderRadius: '10px' }} />
                                            <span className="card-text d-flex align-items-center" style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '-14px' }}>
                                                <i className="bi bi-arrow-right-short" style={{ fontSize: '24px', fontWeight: 'bold' }}></i>
                                                <span style={{ color: '#BC2025', fontFamily: 'Avenir, sans-serif' }}>Business Process Automation</span>
                                            </span>
                                            <span className="card-text d-flex align-items-center" style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '-14px' }}>
                                                <i className="bi bi-arrow-right-short" style={{ fontSize: '24px', fontWeight: 'bold' }}></i>
                                                <span style={{ color: '#BC2025', fontFamily: 'Avenir, sans-serif' }}>AI & Data Analytics Platforms</span>
                                            </span>
                                            <span className="card-text d-flex align-items-center" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                <i className="bi bi-arrow-right-short" style={{ fontSize: '24px', fontWeight: 'bold' }}></i>
                                                <span style={{ color: '#BC2025', fontFamily: 'Avenir, sans-serif' }}>Mobile & Web Application Development</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div className="col">
                                    <div className="card rounded-0 border border-1">
                                        <div className="card-body text-start p-4">
                                            <h5 className="card-title mb-0" style={{
                                                color: '#BC2025',
                                                fontFamily: 'Godber, sans-serif',
                                                fontSize: '28px'
                                            }}>Maintained & Support</h5>
                                            <span className="card-text font-weight-bold d-flex align-items-center mb-3" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                <i className="bi bi-arrow-right-short" style={{ fontSize: '24px', fontWeight: 'bold' }}></i>
                                                <span>(Managed Services)</span>
                                            </span>
                                            <img src="/services/manageService.png" alt="Server Hardware" className="img-fluid mb-2" style={{ maxWidth: '100%', height: 'auto', borderRadius: '10px' }} />
                                            <span className="card-text d-flex align-items-center" style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '-14px' }}>
                                                <i className="bi bi-arrow-right-short" style={{ fontSize: '24px', fontWeight: 'bold' }}></i>
                                                <span style={{ color: '#BC2025', fontFamily: 'Avenir, sans-serif' }}>24/7 IT Support & Monitoring </span>
                                            </span>
                                            <span className="card-text d-flex align-items-center" style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '-14px' }}>
                                                <i className="bi bi-arrow-right-short" style={{ fontSize: '24px', fontWeight: 'bold' }}></i>
                                                <span style={{ color: '#BC2025', fontFamily: 'Avenir, sans-serif' }}>Backup & Disaster Recovery</span>
                                            </span>
                                            <span className="card-text d-flex align-items-center" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                <i className="bi bi-arrow-right-short" style={{ fontSize: '24px', fontWeight: 'bold' }}></i>
                                                <span style={{ color: '#BC2025', fontFamily: 'Avenir, sans-serif' }}>Software Updates & Patch Management</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* About Us Section */}
                <div className="container-fluid px-4 px-md-5 py-5">
                    <div className="row justify-content-center">
                        <div className="col-12" >
                            <h1 className="display-4 text-start mb-0"
                                style={{
                                    ...gradientTextStyle,
                                    fontFamily: 'Godber, sans-serif',
                                    fontSize: '40px'
                                }}>
                                About Us
                            </h1>
                            <h2 className="text-start" style={{ fontFamily: 'Avenir, sans-serif', fontSize: 'clamp(24px, 2vw, 36px)', fontWeight: '700' }}>
                                Vision & Mission
                            </h2>
                            <p className="text-start" style={{ fontFamily: 'Avenir, sans-serif', fontSize: 'clamp(16px, 2vw, 24px)' }}>To be a leading technology partner, empowering businesses with innovative, secure, and scalable IT solutions that drive digital transformation and create lasting impact across industries.</p>

                            <div className="d-grid gap-3 d-sm-flex justify-content-sm-center">
                                <div className="row row-cols-1 row-cols-md-2 row-cols-lg-2 g-4 w-100">
                                    <div className="col">
                                        <div className="card rounded-0 border border-1 h-100">
                                            <div className="card-body text-start d-flex flex-column">
                                                <div className="row flex-column flex-md-row h-100">
                                                    <div className="col-12 col-md-6 mb-3 mb-md-0">
                                                        <div style={{ position: 'relative', paddingBottom: '100%' }}>
                                                            <img
                                                                src="/aboutUs/deliver.png"
                                                                alt="Server Hardware"
                                                                className="img-fluid"
                                                                style={{
                                                                    position: 'absolute',
                                                                    top: 0,
                                                                    left: 0,
                                                                    width: '100%',
                                                                    height: '100%',
                                                                    objectFit: 'cover',
                                                                    borderRadius: '10px'
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-12 col-md-6 d-flex flex-column">
                                                        <span className="text-start" style={{ fontFamily: 'Avenir, sans-serif', fontSize: '16px', fontWeight: 'bold' }}>
                                                            Vision & Mission
                                                        </span>
                                                        <h5 className="card-title mb-3" style={{
                                                            color: '#BC2025',
                                                            fontFamily: 'Godber, sans-serif',
                                                            fontSize: '28px'
                                                        }}>Deliver</h5>
                                                        <p className='text-muted mb-0' style={{ fontFamily: 'Avenir, sans-serif', fontSize: '16px' }}>
                                                            Develop and implement customized software, infrastructure, and cybersecurity solutions tailored to industry needs.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col">
                                        <div className="card rounded-0 border border-1 h-100">
                                            <div className="card-body text-start d-flex flex-column">
                                                <div className="row flex-column flex-md-row h-100">
                                                    <div className="col-12 col-md-6 mb-3 mb-md-0">
                                                        <div style={{ position: 'relative', paddingBottom: '100%' }}>
                                                            <img
                                                                src="/aboutUs/drive.png"
                                                                alt="Server Hardware"
                                                                className="img-fluid"
                                                                style={{
                                                                    position: 'absolute',
                                                                    top: 0,
                                                                    left: 0,
                                                                    width: '100%',
                                                                    height: '100%',
                                                                    objectFit: 'cover',
                                                                    borderRadius: '10px'
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-12 col-md-6 d-flex flex-column">
                                                        <span className="text-start" style={{ fontFamily: 'Avenir, sans-serif', fontSize: '16px', fontWeight: 'bold' }}>
                                                            Digital Transformation
                                                        </span>
                                                        <h5 className="card-title mb-3" style={{
                                                            color: '#BC2025',
                                                            fontFamily: 'Godber, sans-serif',
                                                            fontSize: '28px'
                                                        }}>Drive</h5>
                                                        <p className='text-muted mb-0' style={{ fontFamily: 'Avenir, sans-serif', fontSize: '16px' }}>
                                                            Be the force that drive your businesses vision for a more streamline operations, higher security, and improve efficiency with the latest practice and technology
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col">
                                        <div className="card rounded-0 border border-1 h-100">
                                            <div className="card-body text-start d-flex flex-column">
                                                <div className="row flex-column flex-md-row h-100">
                                                    <div className="col-12 col-md-6 mb-3 mb-md-0">
                                                        <div style={{ position: 'relative', paddingBottom: '100%' }}>
                                                            <img
                                                                src="/aboutUs/ensure.png"
                                                                alt="Server Hardware"
                                                                className="img-fluid"
                                                                style={{
                                                                    position: 'absolute',
                                                                    top: 0,
                                                                    left: 0,
                                                                    width: '100%',
                                                                    height: '100%',
                                                                    objectFit: 'cover',
                                                                    borderRadius: '10px'
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-12 col-md-6 d-flex flex-column">
                                                        <span className="text-start" style={{ fontFamily: 'Avenir, sans-serif', fontSize: '16px', fontWeight: 'bold' }}>
                                                            Reliability & Security
                                                        </span>
                                                        <h5 className="card-title mb-3" style={{
                                                            color: '#BC2025',
                                                            fontFamily: 'Godber, sans-serif',
                                                            fontSize: '28px'
                                                        }}>Ensure</h5>
                                                        <p className='text-muted mb-0' style={{ fontFamily: 'Avenir, sans-serif', fontSize: '16px' }}>
                                                            Provide robust and future-proof IT infrastructure that supports growth and resilience.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col">
                                        <div className="card rounded-0 border border-1 h-100">
                                            <div className="card-body text-start d-flex flex-column">
                                                <div className="row flex-column flex-md-row h-100">
                                                    <div className="col-12 col-md-6 mb-3 mb-md-0">
                                                        <div style={{ position: 'relative', paddingBottom: '100%' }}>
                                                            <img
                                                                src="/aboutUs/innovate.png"
                                                                alt="Server Hardware"
                                                                className="img-fluid"
                                                                style={{
                                                                    position: 'absolute',
                                                                    top: 0,
                                                                    left: 0,
                                                                    width: '100%',
                                                                    height: '100%',
                                                                    objectFit: 'cover',
                                                                    borderRadius: '10px'
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-12 col-md-6 d-flex flex-column">
                                                        <span className="text-start" style={{ fontFamily: 'Avenir, sans-serif', fontSize: '16px', fontWeight: 'bold' }}>
                                                            With Purpose
                                                        </span>
                                                        <h5 className="card-title mb-3" style={{
                                                            color: '#BC2025',
                                                            fontFamily: 'Godber, sans-serif',
                                                            fontSize: '28px'
                                                        }}>Innovate</h5>
                                                        <p className='text-muted mb-0' style={{ fontFamily: 'Avenir, sans-serif', fontSize: '16px' }}>
                                                            Stay ahead of industry trends, leveraging emerging technologies to create smarter, faster, and more efficient IT ecosystems.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* We Serve Section */}
                <div className="container-fluid px-4 px-md-5 py-5">
                    <div className="row justify-content-center">
                        <div className="col-12" >
                            <h1 className="display-4 text-start mb-0"
                                style={{
                                    ...gradientTextStyle,
                                    fontFamily: 'Godber, sans-serif',
                                    fontSize: '40px'
                                }}>
                                We Serve
                            </h1>
                            <h2 className="text-start" style={{ fontFamily: 'Avenir, sans-serif', fontSize: 'clamp(24px, 2vw, 36px)', fontWeight: '700' }}>
                                Variety of Industries
                            </h2>

                            <div className="d-grid d-sm-flex justify-content-sm-center">
                                <div className="row row-cols-2 row-cols-md-2 row-cols-lg-4 g-3">
                                    <div className="col">
                                        <div className="card-body text-start d-flex flex-column h-100">
                                            <h5 className="card-title mb-2" style={{
                                                color: '#BC2025',
                                                fontFamily: 'Godber, sans-serif',
                                                fontSize: 'clamp(16px, 2vw, 24px)'
                                            }}>Corporate & Enterprise</h5>
                                            <div className="mt-auto" style={{ position: 'relative', paddingBottom: '75%' }}>
                                                <img
                                                    src="/serves/1.png"
                                                    alt="Server Hardware"
                                                    className="img-fluid"
                                                    style={{
                                                        position: 'absolute',
                                                        top: 0,
                                                        left: 0,
                                                        width: '100%',
                                                        height: '100%',
                                                        objectFit: 'cover',
                                                        borderRadius: '10px'
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col">
                                        <div className="card-body text-start d-flex flex-column h-100">
                                            <h5 className="card-title mb-2" style={{
                                                color: '#BC2025',
                                                fontFamily: 'Godber, sans-serif',
                                                fontSize: 'clamp(16px, 2vw, 24px)'
                                            }}>Government Sector</h5>
                                            <div className="mt-auto" style={{ position: 'relative', paddingBottom: '75%' }}>
                                                <img
                                                    src="/serves/2.png"
                                                    alt="Server Hardware"
                                                    className="img-fluid"
                                                    style={{
                                                        position: 'absolute',
                                                        top: 0,
                                                        left: 0,
                                                        width: '100%',
                                                        height: '100%',
                                                        objectFit: 'cover',
                                                        borderRadius: '10px'
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col">
                                        <div className="card-body text-start d-flex flex-column h-100">
                                            <h5 className="card-title mb-2" style={{
                                                color: '#BC2025',
                                                fontFamily: 'Godber, sans-serif',
                                                fontSize: 'clamp(16px, 2vw, 24px)'
                                            }}>Healthcare</h5>
                                            <div className="mt-auto" style={{ position: 'relative', paddingBottom: '75%' }}>
                                                <img
                                                    src="/serves/3.png"
                                                    alt="Server Hardware"
                                                    className="img-fluid"
                                                    style={{
                                                        position: 'absolute',
                                                        top: 0,
                                                        left: 0,
                                                        width: '100%',
                                                        height: '100%',
                                                        objectFit: 'cover',
                                                        borderRadius: '10px'
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col">
                                        <div className="card-body text-start d-flex flex-column h-100">
                                            <h5 className="card-title mb-2" style={{
                                                color: '#BC2025',
                                                fontFamily: 'Godber, sans-serif',
                                                fontSize: 'clamp(16px, 2vw, 24px)'
                                            }}>Education</h5>
                                            <div className="mt-auto" style={{ position: 'relative', paddingBottom: '75%' }}>
                                                <img
                                                    src="/serves/4.png"
                                                    alt="Server Hardware"
                                                    className="img-fluid"
                                                    style={{
                                                        position: 'absolute',
                                                        top: 0,
                                                        left: 0,
                                                        width: '100%',
                                                        height: '100%',
                                                        objectFit: 'cover',
                                                        borderRadius: '10px'
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col">
                                        <div className="card-body text-start d-flex flex-column h-100">
                                            <h5 className="card-title mb-2" style={{
                                                color: '#BC2025',
                                                fontFamily: 'Godber, sans-serif',
                                                fontSize: 'clamp(16px, 2vw, 24px)'
                                            }}>Retail & E-Commerce</h5>
                                            <div className="mt-auto" style={{ position: 'relative', paddingBottom: '75%' }}>
                                                <img
                                                    src="/serves/5.png"
                                                    alt="Server Hardware"
                                                    className="img-fluid"
                                                    style={{
                                                        position: 'absolute',
                                                        top: 0,
                                                        left: 0,
                                                        width: '100%',
                                                        height: '100%',
                                                        objectFit: 'cover',
                                                        borderRadius: '10px'
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col">
                                        <div className="card-body text-start d-flex flex-column h-100">
                                            <h5 className="card-title mb-2" style={{
                                                color: '#BC2025',
                                                fontFamily: 'Godber, sans-serif',
                                                fontSize: 'clamp(16px, 2vw, 24px)'
                                            }}>Financial & Banking</h5>
                                            <div className="mt-auto" style={{ position: 'relative', paddingBottom: '75%' }}>
                                                <img
                                                    src="/serves/6.png"
                                                    alt="Server Hardware"
                                                    className="img-fluid"
                                                    style={{
                                                        position: 'absolute',
                                                        top: 0,
                                                        left: 0,
                                                        width: '100%',
                                                        height: '100%',
                                                        objectFit: 'cover',
                                                        borderRadius: '10px'
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col">
                                        <div className="card-body text-start d-flex flex-column h-100">
                                            <h5 className="card-title mb-2" style={{
                                                color: '#BC2025',
                                                fontFamily: 'Godber, sans-serif',
                                                fontSize: 'clamp(16px, 2vw, 24px)'
                                            }}>Industrial Automation</h5>
                                            <div className="mt-auto" style={{ position: 'relative', paddingBottom: '75%' }}>
                                                <img
                                                    src="/serves/7.png"
                                                    alt="Server Hardware"
                                                    className="img-fluid"
                                                    style={{
                                                        position: 'absolute',
                                                        top: 0,
                                                        left: 0,
                                                        width: '100%',
                                                        height: '100%',
                                                        objectFit: 'cover',
                                                        borderRadius: '10px'
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col">
                                        <div className="card-body text-start d-flex flex-column h-100">
                                            <h5 className="card-title mb-2" style={{
                                                color: '#BC2025',
                                                fontFamily: 'Godber, sans-serif',
                                                fontSize: 'clamp(16px, 2vw, 24px)'
                                            }}>Logistics & Transportation</h5>
                                            <div className="mt-auto" style={{ position: 'relative', paddingBottom: '75%' }}>
                                                <img
                                                    src="/serves/8.png"
                                                    alt="Server Hardware"
                                                    className="img-fluid"
                                                    style={{
                                                        position: 'absolute',
                                                        top: 0,
                                                        left: 0,
                                                        width: '100%',
                                                        height: '100%',
                                                        objectFit: 'cover',
                                                        borderRadius: '10px'
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Why Us Section */}
                <div className="container-fluid px-4 px-md-5 py-5">
                    <div className="row justify-content-center">
                        <div className="col-12" >
                            <h1 className="display-4 text-start mb-0"
                                style={{
                                    ...gradientTextStyle,
                                    fontFamily: 'Godber, sans-serif',
                                    fontSize: '40px'
                                }}>
                                Experts
                            </h1>
                            <h2 className="text-start" style={{ fontFamily: 'Avenir, sans-serif', fontSize: 'clamp(24px, 2vw, 36px)', fontWeight: '700' }}>
                                Why Choose Us?
                            </h2>

                            <p className='text-start' style={{ 
                                fontFamily: 'Avenir, sans-serif', 
                                fontSize: 'clamp(16px, 2vw, 24px)'
                            }}>
                                At Cresco, we are committed to delivering scalable, secure, and future-proof IT solutions that empower businesses across industries. No matter the sector, our expertise ensures that your technology investments align with your business goals and industry requirements.
                            </p>

                            <p className='text-start' style={{ 
                                fontFamily: 'Avenir, sans-serif', 
                                fontSize: 'clamp(16px, 2vw, 24px)'
                            }}>
                                We build technology-driven strategies that empower businesses to thrive in the digital era. Whether you need custom software, IT infrastructure, cybersecurity, or digital transformation, we are your trusted technology partner
                            </p>
                        </div>
                    </div>
                </div>

                {/* Our Clients Section */}
                <div className="container-fluid px-4 px-md-5 py-5">
                    <div className="row justify-content-center">
                        <div className="col-12" >
                            <h1 className="display-4 text-start mb-0"
                                style={{
                                    ...gradientTextStyle,
                                    fontFamily: 'Godber, sans-serif',
                                    fontSize: '40px'
                                }}>
                                Technology
                            </h1>
                            <div className="row justify-content-between align-items-center">
                                <div className="col-auto">
                                    <h2 style={{ fontFamily: 'Avenir, sans-serif', fontSize: 'clamp(24px, 2vw, 36px)', fontWeight: 'bold' }}>
                                        Partners of Cresco
                                    </h2>
                                </div>
                                <div className="col-auto">
                                    <button className="btn rounded-0" 
                                        onClick={() => window.location.href = '/partners'} 
                                        style={{ 
                                            width: 'clamp(150px, 20vw, 200px)', 
                                            height: 'clamp(40px, 5vh, 56px)', 
                                            backgroundColor: '#BC2025', 
                                            color: 'white',
                                            fontSize: '16px',
                                            fontWeight: 'bold',
                                            fontFamily: 'Avenir, sans-serif'
                                        }}>
                                        <span className="me-3">View All</span>
                                        <img src="/arrow.png" alt="arrow" style={{ width: '20px', height: '20px' }} />
                                    </button>
                                </div>
                            </div>

                            <div className="row row-cols-2 row-cols-md-3 row-cols-lg-6 g-4 mt-3 px-5">
                                {[1, 2, 3, 4, 5, 6].map((num) => (
                                    <div key={num} className="col">
                                        <div className="card h-100 border-0">
                                            <img
                                                src={`/partner/${num}.png`}
                                                alt={`Partner ${num}`}
                                                className="img-fluid"
                                                style={{
                                                    width: '80%',
                                                    height: '80%',
                                                    objectFit: 'contain'
                                                }}
                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

             {/* Contact Us Section */}
             <div className="container-fluid px-4 px-md-5 py-3" style={{ maxWidth: '1728px', margin: '0 auto' }}>    
                <ContactForm />
            </div>


        </div>
    );
}

export default Homepage; 